import { TreeNodeData } from "@asup/tree-of-nodes";
import { getHierarchyBaseUrl } from "contexts/hierarchy/getHierarchyBaseUrl";
import { HierarchyReadDto } from "functions/api/hierarchy/HierarchyReadDto";
import { HierarchyNodeData } from "./interface";

/**
 * Convert hierarchy DTOs into tree node data used by the tree component.
 *
 * @param hierarchyNodes - The hierarchy nodes to convert
 * @returns An array of tree node data objects
 */
export const hierarchyToNodes = (
  hierarchyNodes: HierarchyReadDto[],
): TreeNodeData<HierarchyNodeData>[] => {
  const treeNodes: TreeNodeData<HierarchyNodeData>[] = [];
  hierarchyNodes.forEach((h) => {
    treeNodes.push({
      id: h.id,
      label: h.name,
      parentId: h.parentId,
      data: {
        ...h,
        url: getHierarchyBaseUrl(h),
      },
    });
  });
  hierarchyNodes.forEach((h) => {
    if (h.children && h.children.length > 0) {
      h.children.forEach((c) => {
        if (treeNodes.findIndex((t) => t.id === c.id) === -1) {
          treeNodes.push({
            id: c.id,
            label: c.name,
            parentId: h.id,
            data: {
              ...c,
              url: getHierarchyBaseUrl(c),
            },
          });
        }
      });
    }
  });
  treeNodes.sort((a, b) => a.label.localeCompare(b.label));
  return treeNodes;
};
